// PlatformSettings.jsx
import React from "react";
export default function PlatformSettings() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Platform Settings</h1>
      <p className="text-gray-300">Global settings panel coming soon.</p>
    </div>
  );
}

